module["exports"] = [
  "Polska"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/pl/address/default_country.js
// module id = 1105
// module chunks = 0